import {useMemo} from 'react';
import {
  resolveHousingName,
  type BookingSummary,
  type ShortReservation,
} from '@chekin/core';
import {getAccessWindow} from '../remoteAccess/helpers';
import {useHomeEnv} from './env';

type StaySource = {summary?: BookingSummary; reservation?: ShortReservation};

function useStaySummary(source?: StaySource) {
  const env = useHomeEnv();
  const {summary, reservation} = source ?? env;

  return useMemo(() => {
    const accessWindow = getAccessWindow(summary, reservation);

    return {
      propertyName: resolveHousingName(summary),
      bookingRef: reservation?.booking_reference || '',
      checkInDate: accessWindow.checkInDate,
      checkInTime: accessWindow.startTime,
      checkOutDate: accessWindow.checkOutDate,
      checkOutTime: accessWindow.endTime,
      nights: summary?.nights_of_stay,
      guests: summary?.expected_guests,
    };
  }, [summary, reservation]);
}

export {useStaySummary};
